import { Attribution } from 'types'

interface Params {
  endDate: string
  startDate: string
  id: string
  attr: Attribution
}

export const getWebsiteSum = ({ endDate, startDate, attr, id }: Params) => {
  switch (attr) {
    case 'first':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(first.new_customers), SUM(first.form_submits), SUM(first.total_orders), SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount) FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}'`
    case 'last':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(last.new_customers), SUM(last.form_submits), SUM(last.total_orders), SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount) FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}'`
    case 'linear':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(linear_page.form_submits), SUM(linear_page.total_orders), SUM(linear_page.total_amount), SUM(linear_page.recurring_payments_amount), SUM(linear_page.orders_amount) FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}'`
    case 'ai':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(ai_page.form_submits), SUM(ai_page.total_orders), SUM(ai_page.total_amount), SUM(ai_page.recurring_payments_amount), SUM(ai_page.orders_amount) FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}'`
    default:
      return ''
  }
}
